const FAVICON_SIZE = 64;

export default function resizeToFavicon(imageSrc: string): Promise<string> {
  const image = new Image();
  if (/^https?:\/\//i.test(imageSrc)) {
    image.crossOrigin = 'anonymous';
  }

  return new Promise((resolve, reject) => {
    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = FAVICON_SIZE;
      canvas.height = FAVICON_SIZE;
      const ctx = canvas.getContext('2d');
      if (!ctx || !image.naturalWidth || !image.naturalHeight) {
        reject(new Error('Could not draw favicon'));
        return;
      }

      const scale = Math.min(
        FAVICON_SIZE / image.naturalWidth,
        FAVICON_SIZE / image.naturalHeight
      );
      const width = image.naturalWidth * scale;
      const height = image.naturalHeight * scale;
      ctx.imageSmoothingQuality = 'high';
      ctx.drawImage(
        image,
        (FAVICON_SIZE - width) / 2,
        (FAVICON_SIZE - height) / 2,
        width,
        height
      );

      try {
        resolve(canvas.toDataURL('image/png'));
      } catch (error) {
        reject(error);
      }
    };
    image.onerror = (error) => reject(error);
    image.src = imageSrc;
  });
}
